export class InsertJob {

  resource: string;
  jobId: string;
  selectedAppFullName: string[];
  selectedLocation: string;
  selectedJobName: string;
  selectedDescription: string;
  selectedStatus: string[];
  selectedStartDate: Date;

  constructor(resource: string, jobId:string, selectedAppFullName: string [], selectedLocation: string , selectedJobName: string, selectedDescription: string,
    selectedStatus: string[] , selectedStartDate: Date){
      this.resource = resource;
    this.jobId = jobId;
    this.selectedAppFullName = selectedAppFullName;
    this.selectedLocation = selectedLocation;
    this.selectedJobName = selectedJobName;
    this.selectedDescription = selectedDescription;
    this.selectedStatus = selectedStatus;
    this.selectedStartDate = selectedStartDate;
    }
  
}